import { COMM_BANNER_BG_COLOR_TYPE } from './types'

export const CLOSED_COMMS_BANNERS_KEY = 'closed_comms_banners'

const HEX_COLOR_CODE_REGEX = /^#?([0-9A-F]{3}){1,2}$/i

export const isValidColorCode = (bgColorCode: string | undefined) =>
	HEX_COLOR_CODE_REGEX.test(bgColorCode ?? '')

export const isValidCustomColor = (
	bgColorType: COMM_BANNER_BG_COLOR_TYPE | undefined,
	bgColorCode: string | undefined
): boolean =>
	Boolean(
		bgColorType === COMM_BANNER_BG_COLOR_TYPE.CUSTOM &&
			isValidColorCode(bgColorCode)
	)

export const isValidPromoColor = (
	bgColorType: COMM_BANNER_BG_COLOR_TYPE | undefined
): boolean =>
	Boolean(
		bgColorType &&
			Object.values(COMM_BANNER_BG_COLOR_TYPE).includes(bgColorType) &&
			bgColorType !== COMM_BANNER_BG_COLOR_TYPE.CUSTOM
	)

export const isValidColor = (
	bgColorType: COMM_BANNER_BG_COLOR_TYPE | undefined,
	bgColorCode: string | undefined
): boolean =>
	Boolean(
		isValidCustomColor(bgColorType, bgColorCode) ||
			isValidPromoColor(bgColorType)
	)
